import {
  ComponentFactoryResolver,
  Directive,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[rdDynamicComponent]',
})
export class DynamicComponentDirective {
  constructor(
    public viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) {}

  remountComponent(component: any): void {
    this.viewContainerRef.clear();

    this.viewContainerRef.createComponent<any>(
      this.componentFactoryResolver.resolveComponentFactory(component),
    );
  }
}
